(() => {
  const query = new URLSearchParams(location.search);
  const incoming = query.get('ref');
  const valid = (value) => /^[A-Z0-9]{6,16}$/i.test(value || '');
  let code = valid(incoming) ? incoming.toUpperCase() : '';
  if (code) {
    try { localStorage.setItem('sw.referral_code', code); localStorage.setItem('sw.referral_at', String(Date.now())); } catch (_) {}
  } else {
    try {
      const saved = localStorage.getItem('sw.referral_code');
      const at = Number(localStorage.getItem('sw.referral_at') || 0);
      if (valid(saved) && Date.now() - at < 30 * 86400000) code = saved;
    } catch (_) {}
  }
  if (!code) return;
  fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ attributes: { 'Saltwooder partner code': code } }), credentials: 'same-origin'
  }).catch(() => {});
})();
